import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useNavigate } from 'react-router-dom';
import './TIJSidebar.css';

// Import all your subcomponents
import Dibal500 from './Dibal500';
import Dibal900 from './Dibal900';
import Dibalpcscale from './Dibalpcscale';
import Dibalwind from './Dibalwind';
import Rongta from './Rongta';
import AIScale from './AIScale';

const RetailWeighingLayout = ({ mode }) => {
  const { type, subType } = useParams();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(type || mode || 'Dibal-scales');
  const [activeSubCategory, setActiveSubCategory] = useState(subType || null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState({
    'Dibal-scales': false, // ZH category
    'Rongta-scales': false,
    'AI-Scales': false  // ZX category
  });

  // Update URL when active category/subcategory changes
  useEffect(() => {
    if (activeSubCategory) {
      navigate(`/retail-scales/${activeCategory}/${activeSubCategory}`);
    } else {
      navigate(`/retail-scales/${activeCategory}`);
    }
  }, [activeCategory, activeSubCategory, navigate]);

  // Handle category switching
  const handleCategoryChange = (category) => {
    setActiveCategory(category);
    setActiveSubCategory(null);
    setIsSidebarOpen(false);
    
    // Toggle category expansion
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  // Handle subcategory selection
  const handleSubCategoryChange = (subCategory) => {
    setActiveSubCategory(subCategory);
    setIsSidebarOpen(false);
  };

  // Toggle category expansion
  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  // Render the active component
  const renderActiveComponent = () => {
    if (activeCategory === 'Dibal-scales' && activeSubCategory) {
      switch (activeSubCategory) {
        case 'Dibal-500': return <Dibal500 />;
        case 'Dibal-900': return <Dibal900 />;
        case 'Dibal-pcscales': return <Dibalwind /> ;
        case 'Dibal-windseries': return <Dibalpcscale />;
        default: return <Dibal500 />;
      }
    } else if (activeCategory === 'Rongta-scales') {
      return <Rongta />;
    } else if(activeCategory === 'AI-Scales'){
      return <AIScale />;
    }
    // Default view when no subcategory is selected for type1
    return <Dibal500/>;
  };

  return (
    <div className="page-container">
      <div className="content-wrap">
        {/* Mobile Navigation (Horizontal) - Simplified for mobile */}
        <div className="mobile-nav">
          <button
            className={`nav-link ${activeCategory === 'Dibal-scales' ? 'active' : ''}`}
            onClick={() => handleCategoryChange('Dibal-scales')}
          >
            Dibal Scales
          </button>
          <button
            className={`nav-link ${activeCategory === 'Rongta-scales' ? 'active' : ''}`}
            onClick={() => handleCategoryChange('Rongta-scales')}
          >
            Rongta Scales
          </button>

          <button
            className={`nav-link ${activeCategory === 'AI-Scales' ? 'active' : ''}`}
            onClick={() => handleCategoryChange('AI-Scales')}
          >
            AI Scales
          </button>
        </div>

        {/* Hamburger Menu Toggle Button */}
        <button
          className="sidebar-toggle"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          ☰
        </button>

        {/* Sidebar */}
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
          <div className="mb-3 px-3 mt-3" style={{fontSize:"18px", fontWeight:"bold", textDecoration:"underline"}}>
            Weighing Scales
          </div>
          
          <nav className="nav flex-column">
            {/* ZH Category with subcategories */}
            <div className="sidebar-category">
              <button
                className={`nav-link category-title ${activeCategory === 'Dibal-scales' ? 'active' : ''}`}
                onClick={() => handleCategoryChange('Dibal-scales')}
              >
                Dibal Scales
                <span className="toggle-icon">
                  {expandedCategories['Dibal-scales'] ? '−' : '+'}
                </span>
              </button>
              
              {expandedCategories['Dibal-scales'] && (
                <div className="subcategories">
                  <button
                    className={`nav-link subcategory ${activeSubCategory === 'Dibal-500' ? 'active' : ''}`}
                    onClick={() => handleSubCategoryChange('Dibal-500')}
                    style={{marginLeft:"13px"}}
                  >
                    Dibal 500 series
                  </button>
                  <button
                    className={`nav-link subcategory ${activeSubCategory === 'Dibal-900' ? 'active' : ''}`}
                    onClick={() => handleSubCategoryChange('Dibal-900')}
                    style={{marginLeft:"13px"}}
                  >
                    Dibal 900 series
                  </button>
                  <button
                    className={`nav-link subcategory ${activeSubCategory === 'Dibal-pcscales' ? 'active' : ''}`}
                    onClick={() => handleSubCategoryChange('Dibal-pcscales')}
                    style={{marginLeft:"13px"}}
                  >
                    Wind series
                  </button>
                  <button
                    className={`nav-link subcategory ${activeSubCategory === 'Dibal-windseries' ? 'active' : ''}`}
                    onClick={() => handleSubCategoryChange('Dibal-windseries')}
                    style={{marginLeft:"13px"}}
                  >
                    PC Scales
                  </button>
                </div>
              )}
            </div>

            {/* ZX Category (no subcategories) */}
            <button
              className={`nav-link ${activeCategory === 'Rongta-scales' ? 'active' : ''}`}
              onClick={() => handleCategoryChange('Rongta-scales')}
            >
              Rongta Scales
            </button>

            <button
              className={`nav-link ${activeCategory === 'AI-Scales' ? 'active' : ''}`}
              onClick={() => handleCategoryChange('AI-Scales')}
            >
              AI Scales
            </button>
          </nav>
        </div>

        {/* Main Content Area */}
        <div className="main-content">
          {renderActiveComponent()}
        </div>
      </div>
    </div>
  );
};

export default RetailWeighingLayout;